import {
  Divider,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import Edicao from './Edicao'
import PrimeTable from '../../../components/PrimeTable'
import GraficoMovimentacao from './GraficoMovimentacao'
import { metodoPrograma } from '../../../components/api'
import GraficoEntradaPorMes from './GraficoEntradaPorMes'
import GraficoSaidaPorMes from './GraficoSaidaPorMes'
import GraficoResultadoPorMes from './GraficoResultadoPorMes'

const MovimentacaoFinanceira = () => {
  const [tela, setTela] = useState('lista')
  const [indicador, setIndicador] = useState({})
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState([])
  const [setDadosItem] = useState(null)

  const voltar = () => {
    setTela('lista')
    setDados(undefined)
  }

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  const getIndicadores = useCallback(() => {
    metodoPrograma('getIndicadores', {}).then((res) => {
      if (res.status) {
        setIndicador(res)
      }
    })
  }, [])

  useEffect(() => {
    getIndicadores()
  }, [getIndicadores])

  return (
    <Programa codigo="CtrlMovimentacaoFinanceira" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} style={{ marginTop: 10 }}>
            <Paper
              elevation={0}
              style={{
                backgroundColor: '#f5f5f5', // cinza bem claro
                borderRadius: '12px', // bordas arredondadas
                padding: '16px',
              }}
            >
              <Typography
                variant="h7"
                style={{ marginBottom: '10px', fontWeight: 500 }}
              >
                Movimentações
              </Typography>
              <Divider style={{ marginBottom: 15 }} />
              {indicador.totalEntradas && indicador.totalSaidas && (
                <GraficoMovimentacao indicador={indicador} />
              )}
            </Paper>
          </Grid>
          <Grid item xs={12} md={3} style={{ marginTop: 10 }}>
            <Paper
              elevation={0}
              style={{
                backgroundColor: '#f5f5f5', // cinza bem claro
                borderRadius: '12px', // bordas arredondadas
                padding: '16px',
              }}
            >
              <Typography
                variant="h7"
                style={{ marginBottom: '10px', fontWeight: 500 }}
              >
                Entradas dos últimos 6 meses
              </Typography>
              <Divider style={{ marginBottom: 15 }} />
              {indicador.entradas6meses && (
                <GraficoEntradaPorMes indicador={indicador} />
              )}
            </Paper>
          </Grid>
          <Grid item xs={12} md={3} style={{ marginTop: 10 }}>
            <Paper
              elevation={0}
              style={{
                backgroundColor: '#f5f5f5', // cinza bem claro
                borderRadius: '12px', // bordas arredondadas
                padding: '16px',
              }}
            >
              <Typography
                variant="h7"
                style={{ marginBottom: '10px', fontWeight: 500 }}
              >
                Saídas dos últimos 6 meses
              </Typography>
              <Divider style={{ marginBottom: 15 }} />
              {indicador.saidas6meses && (
                <GraficoSaidaPorMes indicador={indicador} />
              )}
            </Paper>
          </Grid>
          <Grid item xs={12} md={3} style={{ marginTop: 10 }}>
            <Paper
              elevation={0}
              style={{
                backgroundColor: '#f5f5f5', // cinza bem claro
                borderRadius: '12px', // bordas arredondadas
                padding: '16px',
              }}
            >
              <Typography
                variant="h7"
                style={{ marginBottom: '10px', fontWeight: 500 }}
              >
                Resultado dos últimos 6 meses
              </Typography>
              <Divider style={{ marginBottom: 15 }} />
              {indicador.resultadoPorMes && (
                <GraficoResultadoPorMes indicador={indicador} />
              )}
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <PrimeTable
              codigo="CtrlMovimentacaoFinanceira"
              action="lista"
              rows={10}
              habSearch
              collumnsDateHour={[4]}
              collumnsCurrency={[5]}
              head={[
                'Descrição',
                'Empresa',
                'Plano de Conta',
                'Centro de Custo',
                'Data',
                'Valor',
              ]}
              line={(item) => [
                item[6],
                item[2][1],
                item?.[10]?.[1],
                item?.[11]?.[1],
                item[3],
                item[4] === 'S' ? item[5] * -1 : item[5],
              ]}
              onRowSelect={handleClick}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar, setTela, setDadosItem }} />
      )}
    </Programa>
  )
}

export default MovimentacaoFinanceira
